import { createSvgIcon } from "@mui/material";

export const PlacementLeftIcon = createSvgIcon(
  <svg viewBox="0 0 12 9" fill="none">
    <path
      fill="currentColor"
      d="M.001.844a.85.85 0 0 0 .844.844h5.063c.474 0 .843-.37.843-.844A.85.85 0 0 0 5.907 0H.845a.87.87 0 0 0-.844.844M0 4.219a.85.85 0 0 0 .844.843h10.125a.833.833 0 0 0 .844-.843.85.85 0 0 0-.844-.844H.844A.87.87 0 0 0 0 4.219m.001 3.375a.85.85 0 0 0 .844.843h5.063a.83.83 0 0 0 .843-.843.85.85 0 0 0-.844-.844H.845a.87.87 0 0 0-.844.844"
    />
  </svg>,
  "PlacementLeftIcon",
);
